/**
 * Clear all Korean Grammar app related localStorage items
 */
export function clearAllLocalStorage(): void {
  const keysToRemove = [
    // Vault related
    'korean-grammar-vault-path',
    'korean-grammar-current-vault',
    'korean-grammar-recent-vaults',
    'korean-grammar-last-directory',
    
    // File/Tab related  
    'korean-grammar-open-tabs',
    'korean-grammar-active-tab',
    'korean-grammar:folder-structure',
    
    // Settings
    'korean-grammar:settings',
    'korean-grammar:shortcuts',
    'korean-grammar:usage',
    'korean-grammar:systemPrompt',
    'sidebarPreferences',
    'autoStart',
    'autoUpdate',
    
    // Auth/Subscription
    'subscription_trial_info',
    'authToken',
    'deviceId',
    
    // Logs
    'service_logs'
  ];

  // Get all localStorage keys
  const allKeys = Object.keys(localStorage);
  let removedCount = 0;

  // Remove korean-grammar related keys
  allKeys.forEach(key => {
    if (key.includes('korean-grammar') || keysToRemove.includes(key)) {
      localStorage.removeItem(key);
      removedCount++;
    }
  });
}

/**
 * Clear only vault and recent folders related localStorage items
 */
export function clearVaultStorage(): void {
  const vaultKeys = [
    'korean-grammar-vault-path',
    'korean-grammar-current-vault',
    'korean-grammar-recent-vaults',
    'korean-grammar-last-directory',
    'korean-grammar-open-tabs',
    'korean-grammar-active-tab',
    'korean-grammar:folder-structure'
  ];

  vaultKeys.forEach(key => {
    if (localStorage.getItem(key) !== null) {
      localStorage.removeItem(key);
    }
  });
}